import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatetimeFormatLanguageEnum } from 'src/app/enum/datetime-format-language.enum';
import * as moment from 'moment';
import { LanguageBase } from 'src/app/envelope/model/language';
import { LanguageUtil } from 'src/app/util/language-util';
import { DateTimeInfo } from '../../verification/models/date-time-info';

@Pipe({ name: 'datetimeFormatLanguage' })
export class DatetimeFormatLanguage implements PipeTransform {
  languageBase: LanguageBase;
  constructor(
    private translateService: TranslateService) {
    this.languageBase = new LanguageBase(translateService);
  }
  transform(datetimeInfo: DateTimeInfo, before: DatetimeFormatLanguageEnum, after: string): string {
    if (!datetimeInfo && datetimeInfo[0]) {
      return "";
    } else {
      switch (before) {
        case DatetimeFormatLanguageEnum.datetime:
          return this.datetime(datetimeInfo);
        case DatetimeFormatLanguageEnum.datetimeFormatted:
          return this.datetimeFormatted(datetimeInfo);
        case DatetimeFormatLanguageEnum.datetimeUtcFormatted:
          return this.datetimeUtcFormatted(datetimeInfo);
        default:
          break;
      }
    }
  }

  datetimeFormatted(datetimeInfo: DateTimeInfo) {
    switch (this.translateService.currentLang) {
      case LanguageUtil.pt:
      case LanguageUtil.es:
      default:
        return moment(datetimeInfo.datetime).format("DD/MM/yyyy") + " às " + moment(datetimeInfo.datetime).format("HH:mm");
      case LanguageUtil.en:
        return moment(datetimeInfo.datetime).format("MM/DD/yyyy") + " at " + moment(datetimeInfo.datetime).format("HH:mm");
    }
  }

  datetime(datetimeInfo: DateTimeInfo) {
    switch (this.translateService.currentLang) {
      case LanguageUtil.pt:
      case LanguageUtil.es:
      default:
        return moment(datetimeInfo.datetime).format("DD/MM/yyyy");
      case LanguageUtil.en:
        return moment(datetimeInfo.datetime).format("MM/DD/yyyy");
    }
  }

  datetimeUtcFormatted(datetimeInfo: DateTimeInfo) {    
    switch (this.translateService.currentLang) {
      case LanguageUtil.es:
        return moment(datetimeInfo.datetime).format("DD/MM/yyyy") + " a " + moment(datetimeInfo.datetime).format("HH:mm") +
          " • Huso Horario: UTC " + datetimeInfo.utcFormatted;
      case LanguageUtil.pt:
      default:
        return moment(datetimeInfo.datetime).format("DD/MM/yyyy") + " às " + moment(datetimeInfo.datetime).format("HH:mm") +
          " • Fuso Horário: UTC " + datetimeInfo.utcFormatted;
      case LanguageUtil.en:
        return moment(datetimeInfo.datetime).format("MM/DD/yyyy") + " at " + moment(datetimeInfo.datetime).format("HH:mm") +
          " • Timezone: UTC " + datetimeInfo.utcFormatted;
    }
  }
}


